import { TransferOrdersActionTypes } from "./constants";

// ── List ──────────────────────────────────────────────────────────────────
export const getTransferOrdersList = (params: {
  limit?: number;
  skip?: number;
  status?: string;
  country?: string;
  agent?: string;
  keyword?: string;
}) => ({
  type: TransferOrdersActionTypes.GET_LIST,
  payload: { limit: 20, skip: 0, ...params },
});

export const transferOrdersGetListSuccess = (data: any) => ({
  type: TransferOrdersActionTypes.GET_LIST_SUCCESS,
  payload: data,
});

export const transferOrdersGetListError = (error: any) => ({
  type: TransferOrdersActionTypes.GET_LIST_ERROR,
  payload: error,
});

// ── Create ────────────────────────────────────────────────────────────────
export const createTransferOrder = (data: {
  customerName: string;
  customerPhone: string;
  customerAddress: string;
  product: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  advanceAmount: number;
  transporterName?: string;
  transporterPhone?: string;
  notes?: string;
  country: string;
}) => ({
  type: TransferOrdersActionTypes.CREATE,
  payload: data,
});

export const createTransferOrderSuccess = (data: any) => ({
  type: TransferOrdersActionTypes.CREATE_SUCCESS,
  payload: data,
});

export const createTransferOrderError = (error: any) => ({
  type: TransferOrdersActionTypes.CREATE_ERROR,
  payload: error,
});

// ── Get one ───────────────────────────────────────────────────────────────
export const getTransferOrderAction = (id: string) => ({
  type: TransferOrdersActionTypes.GET_ONE,
  payload: { id },
});

export const getTransferOrderSuccess = (data: any) => ({
  type: TransferOrdersActionTypes.GET_ONE_SUCCESS,
  payload: data,
});

export const getTransferOrderError = (error: any) => ({
  type: TransferOrdersActionTypes.GET_ONE_ERROR,
  payload: error,
});

// ── Update ────────────────────────────────────────────────────────────────
export const updateTransferOrder = (id: string, data: any) => ({
  type: TransferOrdersActionTypes.UPDATE,
  payload: { id, data },
});

export const updateTransferOrderSuccess = (data: any) => ({
  type: TransferOrdersActionTypes.UPDATE_SUCCESS,
  payload: data,
});

export const updateTransferOrderError = (error: any) => ({
  type: TransferOrdersActionTypes.UPDATE_ERROR,
  payload: error,
});

// ── Update status ─────────────────────────────────────────────────────────
export const updateStatusTransferOrder = (
  id: string,
  data: {
    status: string;
    advanceProofUrl?: string;
    paidAdvance?: number;
    trackingNumber?: string;
    notes?: string;
  }
) => ({
  type: TransferOrdersActionTypes.UPDATE_STATUS,
  payload: { id, data },
});

export const updateStatusTransferOrderSuccess = (data: any) => ({
  type: TransferOrdersActionTypes.UPDATE_STATUS_SUCCESS,
  payload: data,
});

export const updateStatusTransferOrderError = (error: any) => ({
  type: TransferOrdersActionTypes.UPDATE_STATUS_ERROR,
  payload: error,
});

// ── Delete ────────────────────────────────────────────────────────────────
export const deleteTransferOrder = (id: string) => ({
  type: TransferOrdersActionTypes.DELETE,
  payload: { id },
});

export const deleteTransferOrderSuccess = () => ({
  type: TransferOrdersActionTypes.DELETE_SUCCESS,
  payload: {},
});

export const deleteTransferOrderError = (error: any) => ({
  type: TransferOrdersActionTypes.DELETE_ERROR,
  payload: error,
});
